(function() {
    /**
        * initMap
        *
        * Renders a Google Map onto the selected element
        *
        * @date    22/10/19
        * @since   5.8.6
        *
        * @param   HTMLElement el The DOM element.
        * @return  object The map instance.
        */
    function initMap(el) {
        // Find marker elements within map.
        var markers = el.querySelectorAll('.marker');

        // Create generic map.
        var mapArgs = {
            zoom: parseInt(el.dataset.zoom) || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            draggable: false,
            styles: [
                {
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#616161"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.stroke",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#bdbdbd"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#eeeeee"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ffffff"
                    }
                  ]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#dadada"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#616161"
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "transit.line",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "transit.station",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#eeeeee"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#c9c9c9"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                }
              ]
        };
        var map = new google.maps.Map(el, mapArgs);

        // Add markers.
        map.markers = [];
        markers.forEach(function(markerEl) {
            initMarker(el, markerEl, map);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    /**
        * initMarker
        *
        * Creates a marker for the given element and map.
        *
        * @date    22/10/19
        * @since   5.8.6
        *
        * @param   HTMLElement markerEl The DOM element.
        * @param   object The map instance.
        * @return  object The marker instance.
        */
    function initMarker(mapEl, markerEl, map) {

        // Get position from marker.
        var lat = markerEl.dataset.lat;
        var lng = markerEl.dataset.lng;
        var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

        // Create marker instance.
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            title: markerEl.dataset.title || "",
            icon: mapEl.dataset.pin
        });

        // Append to reference for later use.
        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow.
        if (markerEl.innerHTML) {

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: markerEl.innerHTML
            });

            // Show info window when marker is clicked.
            marker.addListener('click', function() {
                infowindow.open(map, marker);
                var location = markerEl.dataset.location;

                // Update the URL by adding the tag
                fetchUpdatedContent(location);
            });
        } else {
            marker.addListener('click', function() {
                var location = markerEl.dataset.location;

                // Update the URL by adding the tag
                fetchUpdatedContent(location);
            });
        }
    }

    /**
        * centerMap
        *
        * Centers the map showing all markers in view.
        *
        * @date    22/10/19
        * @since   5.8.6
        *
        * @param   object The map instance.
        * @return  void
        */
    function centerMap(map) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function(marker) {
            bounds.extend(marker.getPosition());
        });

        // Case: Single marker.
        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());

        // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

    /**
     * updateUrl
     *
     * Adds or removes the tag from the URL without reloading the page.
     *
     * @param   string|null tag The tag to add or remove.
     * @return  void
     */
    function fetchUpdatedContent(tag) {
        var currentUrl = new URL(window.location.href);
        var path = currentUrl.pathname;

        // Check if /tagged/ exists in the URL
        var taggedIndex = path.indexOf('/tagged/');

        // If /tagged/ exists, extract existing tags
        if (taggedIndex !== -1) {
            var tagString = path.substring(taggedIndex + 8); // Extract tags after /tagged/
            var tags = tagString.split('+');

            if (tags.length === 1 && tags[0]) {
                // If there's one tag, add the second tag
                tags.push(tag);
            } else if (tags.length === 2) {
                // If there are already two tags, replace the second one with the new tag
                tags[1] = tag;
            }

            // Update the URL path with the new tag structure
            path = path.substring(0, taggedIndex + 8) + tags.join('+');
        } else {
            // If /tagged/ doesn't exist, add it to the URL with the new tag
            path += '/tagged/' + tag;
        }

        // Build the full URL with the query parameters (like ?view=trainers)
        var newUrl = currentUrl.origin + path + currentUrl.search;

        // Fetch the content from the new URL
        fetch(newUrl)
            .then(response => response.text())
            .then(html => {
                // Parse the response and extract the .trainers-list
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newTrainersList = doc.querySelector('.trainers-list');

                if (newTrainersList) {
                    // Replace the current .trainers-list with the new one
                    var currentTrainersList = document.querySelector('.trainers-list');
                    currentTrainersList.innerHTML = newTrainersList.innerHTML;
                }
            })
            .catch(error => {
                console.error('Error fetching the new content:', error);
            });
    }

    // Render maps on page load.
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.map').forEach(function(el) {
            initMap(el);
        });
    });

})();